






































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import {
  AdminDto,
  BrandDto,
  ProductConsultDto,
  ProductConsultListDto,
  ProductConsultStatusUpdateDto,
} from '@/dto';
import ProductConsultService from '@/services/product-consult.service';
import { CONST_YN, OrderByValue, Pagination, YN } from '@/common';
import {
  ClearOutQueryParamMapper,
  QueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';
import {
  APPROVAL_STATUS,
  CONST_APPROVAL_STATUS,
  CONST_PAGINATION_COUNT,
  CONST_PRODUCT_CONSULT,
  PaginationCount,
  PRODUCT_CONSULT,
} from '@/services/shared';
import router from '@/router';
import { getStatusColor } from '@/core/utils/status-color.util';
import CodeManagementService from '@/services/code-management.service';
import { CodeManagementDto } from '@/services/init/dto';
import AdminService from '@/services/admin.service';
import BrandService from '@/services/brand.service';

@Component({
  name: 'ProductConsultList',
})
export default class ProductConsultList extends BaseComponent {
  private productConsultDto = new ProductConsultDto();
  private brandList: BrandDto[] = [];
  private productConsultSearchDto = new ProductConsultListDto();
  private pagination = new Pagination();
  private productConsultTotalCount = null;
  private productConsultListDto: ProductConsultDto[] = [];
  private dataLoading = false;
  private statusSelect: CodeManagementDto[] = [];
  private adminList: AdminDto[] = [];
  private availableTimesSelect: CodeManagementDto[] = [];
  private expYn: YN[] = [...CONST_YN];
  private genderSelect: CodeManagementDto[] = [];
  private newLimit = null;
  private paginationCount: PaginationCount[] = [...CONST_PAGINATION_COUNT];
  private codeManagement: CodeManagementDto[] = [];
  // 선택된 상품 상담 ID
  private selectedProductConsultNos: number[] = [];
  private productConsultUpdateStatusDto = new ProductConsultStatusUpdateDto();
  private newDate = new Date();
  // excel options
  private fields = {
    이름: 'nanudaUser.name',
    연락처: 'nanudaUser.phone',
    비회원명: 'nonUserName',
    비회원연락처: 'nonUserPhone',
    성별: 'nanudaUser.genderInfo.value',
    상담시간: 'availableTime.value',
    신청일: 'createdAt',
    창업경험: 'changUpExpYn',
    신청상태: 'codeManagement.value',
    주소: 'addressInfo.name',
    비고: 'pConsultEtc',
    관심브랜드: 'brand.nameKr',
  };
  private json_meta = [
    [
      {
        key: 'charset',
        value: 'utf-8',
      },
    ],
  ];

  findAdmin() {
    AdminService.findForSelect().subscribe(res => {
      if (res) {
        this.adminList = res.data;
      }
    });
  }

  findBrands() {
    BrandService.findNanudaBrand().subscribe(res => {
      this.brandList = res.data;
    });
  }

  findOne(id) {
    ProductConsultService.findOne(id).subscribe(res => {
      this.productConsultDto = res.data;
      CodeManagementService.findAnyCode('PRODUCT_CONSULT').subscribe(res => {
        this.codeManagement = res.data;
      });
    });
  }

  updateProductConsult() {
    ProductConsultService.update(
      this.productConsultDto.no,
      this.productConsultDto,
    ).subscribe(res => {
      this.search();
    });
  }

  updateProductConsultNos() {
    if (this.selectedProductConsultNos.length > 0) {
      this.productConsultUpdateStatusDto.productConsultNos = this.selectedProductConsultNos;
      ProductConsultService.updateStatus(
        this.productConsultUpdateStatusDto,
      ).subscribe(res => {
        this.selectedProductConsultNos = [];
        this.statusSelect = [];
        this.search();
      });
    }
  }

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // get product consult codes
  getProductConsultCodes() {
    CodeManagementService.findAnyCode('PRODUCT_CONSULT').subscribe(res => {
      this.statusSelect = res.data;
    });
  }

  // 성별
  getGender() {
    CodeManagementService.findGender().subscribe(res => {
      this.genderSelect = res.data;
    });
  }

  // 희망시간대
  getAvailableTimes() {
    CodeManagementService.findAvailableTimes().subscribe(res => {
      this.availableTimesSelect = res.data;
    });
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    this.pagination.limit = this.newLimit;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.productConsultSearchDto, this.pagination);
    }
    ProductConsultService.findAll(
      this.productConsultSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.productConsultListDto = res.data.items;
        this.productConsultTotalCount = res.data.totalCount;
      }
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.productConsultSearchDto = new ProductConsultListDto();
      this.findAll();
    }
  }

  created() {
    this.newLimit = PaginationCount.TWENTY;
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.productConsultSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.newLimit = +query.limit;
        // this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getProductConsultCodes();
    this.findBrands();
    this.getAvailableTimes();
    this.getGender();
    this.findAdmin();
  }
}
